import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  container: {
    paddingRight: '1rem',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
  },
  subtitle: {
    fontSize: '1rem',
    fontWeight: 'lighter',
  },
  box: {
    gap: '1rem',
    background: '#eef0ee',
    padding: '1rem',
    width: '100%',
    borderRadius: '1rem',
    maxWidth: '400px',
    '-webkit-box-shadow': '10px 10px 20px -20px rgba(0,0,0,0.2)',
    '-moz-box-shadow': '10px 10px 57px -20px rgba(0,0,0,0.2)',
    boxShadow: '10px 10px 57px -20px rgba(0,0,0,0.2)',
    [theme.breakpoints.between(0, 1050)]: {
      minWidth: '220px',
    },
    '& > img': {
      width: '100%',
      borderRadius: '0.875rem',
      cursor: 'zoom-in',
    },
  },
  boxTitle: {
    color: '#353535',
    fontWeight: 600,
    fontSize: '0.875rem',
  },
  boxSubtitle: {
    color: '#353535',
    fontWeight: 400,
    fontSize: '0.75rem',
  },
  boxError: {
    width: '80%',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '1rem',
  },
  infoButton: {
    marginTop: '0.5rem',
    padding: '0.5rem 1.2rem',
    background: theme.palette.primary.main,
    color: '#ffff',
    border: 'none',
    borderRadius: '0.5rem',
    fontWeight: 600,
    fontSize: '1rem',
    cursor: 'pointer',
    transition: 'background 0.2s',
    boxShadow: theme.shadows[2],
    '&:hover': {
      background: theme.palette.primary.dark,
    },
  },
  tableRow: {
    '&:nth-of-type(even)': {
      background: '#F4F4F4',
    },
  },
  tableCell: {
    padding: '0.7rem 1rem',
    fontSize: '1rem',
    borderBottom: 'none',
  },
  tableHeadCell: {
    fontWeight: 600,
    fontSize: '1.05rem',
    background: '#eaeaea',
    padding: '0.7rem 1rem',
  },
  consideredCell: {
    textAlign: 'center',
    verticalAlign: 'middle',
    fontSize: '1.1rem',
  },
  dialogTitle: {
    textAlign: 'center',
    width: '100%',
    fontWeight: 700,
    fontSize: '1.3rem',
  },
  dialogActions: {
    justifyContent: 'center',
    width: '100%',
    paddingBottom: '1.5rem',
  },
  tableWrapper: {
    width: '100%',
    overflowX: 'auto',
  },
  '@media (max-width: 600px)': {
    dialogPaper: {
      minWidth: '95vw',
      maxWidth: '98vw',
    },
  },
}))
